import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/BroadcastBanner.css';

function BroadcastBanner({ onNavigate }) {
  const [broadcasts, setBroadcasts] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    fetchBroadcasts();
  }, []);

  const fetchBroadcasts = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/broadcasts/active`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBroadcasts(response.data);
    } catch (error) {
      console.error('Error fetching broadcasts:', error);
    }
  };

  const dismissBroadcast = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        `${process.env.REACT_APP_API_URL}/broadcasts/${id}/dismiss`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      setBroadcasts(broadcasts.filter(b => b.id !== id));
      if (currentIndex >= broadcasts.length - 1) {
        setCurrentIndex(Math.max(0, broadcasts.length - 2));
      }
    } catch (error) {
      console.error('Error dismissing broadcast:', error);
    }
  };

  const handleLinkClick = (linkAction) => {
    if (onNavigate && linkAction) {
      onNavigate(linkAction);
    }
  };

  if (broadcasts.length === 0) return null;

  const currentBroadcast = broadcasts[currentIndex];

  const getTypeIcon = (type) => {
    switch (type) {
      case 'maintenance':
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
          </svg>
        );
      case 'urgent':
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
        );
      case 'feature':
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
          </svg>
        );
      default:
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="16" x2="12" y2="12"/>
            <line x1="12" y1="8" x2="12.01" y2="8"/>
          </svg>
        );
    }
  };

  return (
    <div className={`broadcast-banner ${currentBroadcast.type}`}>
      <div className="broadcast-content">
        <div className="broadcast-icon">
          {getTypeIcon(currentBroadcast.type)}
        </div>
        <div className="broadcast-text">
          <strong>{currentBroadcast.title}</strong>
          <span>{currentBroadcast.message}</span>
        </div>
        {currentBroadcast.link_text && currentBroadcast.link_action && (
          <button 
            className="broadcast-link"
            onClick={() => handleLinkClick(currentBroadcast.link_action)}
          >
            {currentBroadcast.link_text} →
          </button>
        )}
      </div>
      <div className="broadcast-actions">
        {broadcasts.length > 1 && (
          <div className="broadcast-pagination">
            <button
              onClick={() => setCurrentIndex(Math.max(0, currentIndex - 1))}
              disabled={currentIndex === 0}
              className="pagination-btn"
            >
              ‹
            </button>
            <span className="pagination-text">{currentIndex + 1} / {broadcasts.length}</span>
            <button
              onClick={() => setCurrentIndex(Math.min(broadcasts.length - 1, currentIndex + 1))}
              disabled={currentIndex === broadcasts.length - 1}
              className="pagination-btn"
            >
              ›
            </button>
          </div>
        )}
        {currentBroadcast.is_dismissible && (
          <button 
            className="broadcast-dismiss"
            onClick={() => dismissBroadcast(currentBroadcast.id)}
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
}

export default BroadcastBanner;
